import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const { user } = useAuth();
  const isCompany = user?.role === "company";
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: null });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", payment_status: "missing" }); return; }
    let attempts = 0;
    const maxAttempts = 6;
    let timer;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ status: "success", payment_status: "paid" });
          return;
        }
        if (data.status === "expired") {
          setState({ status: "error", payment_status: "expired" });
          return;
        }
        attempts += 1;
        if (attempts >= maxAttempts) {
          setState({ status: "timeout", payment_status: data.payment_status });
          return;
        }
        timer = setTimeout(poll, 2000);
      } catch (e) {
        setState({ status: "error", payment_status: "error" });
      }
    };
    poll();
    return () => timer && clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="container-x py-20 max-w-xl" data-testid="payment-success-page">
      <div className="card-soft text-center">
        {state.status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-[#1E3F33] animate-spin"/>
            <h1 className="font-heading text-2xl text-[#1E3F33] mt-5">Confirming your payment…</h1>
            <p className="text-[#5C6B64] mt-2">This usually takes a few seconds.</p>
          </>
        )}
        {state.status === "success" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#2D6A4F]"/>
            <h1 className="font-heading text-2xl text-[#1E3F33] mt-5">You're now a <span className="text-[#B91C1C]">Screening Services Mobile</span> Pro!</h1>
            <p className="text-[#5C6B64] mt-2">{isCompany ? "Your collectors are now active and will start receiving customer leads." : "Your Certified Pro badge is now active. Customers will see you in search."}</p>
            <Link to={isCompany ? "/dashboard/company" : "/dashboard/collector"} data-testid="go-to-dashboard-link" className="btn-primary inline-block mt-6">Go to dashboard</Link>
          </>
        )}
        {(state.status === "error" || state.status === "timeout") && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-[#E63946]"/>
            <h1 className="font-heading text-2xl text-[#1E3F33] mt-5">Payment {state.payment_status || "issue"}</h1>
            <p className="text-[#5C6B64] mt-2">Please try again or contact support if you were charged.</p>
            <Link to={isCompany ? "/dashboard/company" : "/subscribe"} className="btn-primary inline-block mt-6">Try again</Link>
          </>
        )}
      </div>
    </div>
  );
}
